// extracted by mini-css-extract-plugin
export default {"container":"JoinStudioPageV2_container__y2Ce2","back":"JoinStudioPageV2_back__DhvNe","header":"JoinStudioPageV2_header__zeKn3","map":"JoinStudioPageV2_map__YjhG7"};